module.exports = __webpack_public_path__ + "img/img_flag_pm.8abcad68.png";